
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  onClick?: () => void;
}

const Card = ({ children, onClick }: CardProps) => {
  return (
    <div className="card" onClick={onClick} style={{ cursor: 'pointer'}}>
      <div>
        {children}
      </div>
    </div>
  );
}

export default Card;

